import { Component, OnInit } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import * as moment from "moment";
import { ImcService } from "src/services/imc.service";

@Component({
  selector: "app-imc-component",
  templateUrl: "./imc-component.component.html",
  styleUrls: ["./imc-component.component.scss"],
})
export class ImcComponentComponent implements OnInit {
  emptyState = {
    imgUrl: "/assets/imgs/bg-diario-saude.svg",
    title: "O paciente não possui nenhum registro de IMC.",
    text: "O usuário ainda não registrou nenhum dado sobre seu Índice de Massa Corpórea.",
  };

  emptyStateFiltered = {
    imgUrl: "/assets/imgs/bg-diario-saude.svg",
    title:
      "O paciente não possui nenhum registro de IMC, de acordo com filtro aplicado.",
    text: "O usuário ainda não registrou nenhum dado sobre seu Índice de Massa Corpórea, de acordo com filtro aplicado.",
  };

  imcList: any[] = [];
  imcListFiltered: any[] = [];
  dtFim: any;
  dtInicio: any;
  conteudoRevelado = false;
  listaFiltro: any[] = [];
  filtrosSelecionados: any[] = [];

  constructor(
    private loadingCtrl: LoadingController,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private imcService: ImcService
  ) { }

  ordem(lista) {
    console.log('=======listaimc', lista)
    return lista.sort((a, b) => {
      let oldDateFormatA = moment(a.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = moment(b.dtAtualizacao, "DD-MM-YYYY HH:mm")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    })
  }

  async ngOnInit() {
    await this.loadData();

    this.listaFiltro = ["Adequado", "Acima do peso", "Obeso"];
  }

  async loadData() {
    this.loadingCtrl.create();
    this.imcList = await this.imcService.recuperar();
    this.formatarConteudo(false);
    this.loadingCtrl.dismiss();
  }

  formatarConteudo(hidden: boolean) {
    this.imcListFiltered = this.imcList.map((imc) => ({
      tipo: "IMC",
      nome: "IMC",
      dtAtualizacao: imc.data,
      imc: imc.imc,
    }));

    if (hidden) {
      this.imcListFiltered = this.imcListFiltered.slice(0, 3);
    }
  }

  revelarConteudo() {
    this.formatarConteudo(false);
    this.conteudoRevelado = true;
  }

  async filter(datas?: any) {
    if (datas) {
      this.dtInicio = datas.dtInicio;
      this.dtFim = datas.dtFim;
    }
    this.revelarConteudo();

    if (this.dtInicio && !moment(this.dtInicio, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data de início invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtInicio = null;
    }
    if (this.dtFim && !moment(this.dtFim, "DD/MM/YYYY").isValid()) {
      const toast = await this.toastController.create({
        message: "Data fim invalida!",
        position: "top",
        duration: 4000,
        cssClass: "toast-error",
      });
      await toast.present();
      this.dtFim = null;
    }

    if (this.dtInicio && this.dtFim) {
      this.imcListFiltered = this.imcListFiltered.filter((atendimento) => {
        const dtAtendimento = moment(atendimento.dtAtualizacao, "YYYY-MM-DD");
        const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
        const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

        return dtAtendimento.isBetween(dtInicio, dtFim);
      });
    }

    if (this.filtrosSelecionados.length) {
      this.imcListFiltered = this.imcListFiltered.filter((imc) => {
        return this.filtrosSelecionados.includes(
          this.getImcStatus(imc.imc).toLocaleLowerCase()
        );
      });
    }
  }

  getImcStatus(imc: number) {
    if (!imc) {
      return " - ";
    }
    if (imc <= 25) {
      return "Adequado";
    } else if (imc < 30) {
      return "Acima do peso";
    } else {
      return "Obeso";
    }
  }

  addFilter(data) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    if (!this.filtrosSelecionados.includes(data)) {
      this.filtrosSelecionados.push(data.toLowerCase());
    }

    this.filter();
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        this.filter();
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      await this.filter();
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
    this.formatarConteudo(false);
    this.filter()

  }
}
